@if (vm$ | async; as vm) {
  <ng-container *transloco="let t; read: 'revisions.detail'">
    <ng-container *transloco="let tGlobal">
      <div class="xs12col">
        <div class="fieldsetWrapper margin-right-small margin-bottom-medium">
          <fieldset class="fieldsetContainer flexRow">
            <div class="titleAdd flexRow padding-bottom-medium">
              <h2 class="padding-right-small">{{ t('wearingParts.title') }}</h2>
              <div class="functionContainer">
                @if (('Permissions.WearingParts.Export' | permission)) {
                  <div class="flexRow align-center">
                    <button
                      kendoButton
                      class="addIcon small"
                      (click)="exportWearingParts()"
                      loadingIndication="/wearingParts/exportWearingPartsByRevision/">
                      <span class="k-button-text">
                        <span class="icon">
                          <img src="../../../assets/icons/upload-icon.svg">
                        </span>
                      </span>
                    </button>
                    <span>{{ t('wearingParts.export') }}</span>
                    <span  class="tooltipContainer">
                      <span [attr.tooltip]="t('wearingParts.tooltipExport')" flow="right" class="tooltipContainer">
                        <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                      </span>
                    </span>
                  </div>
                }
                @if (('Permissions.WearingParts.Export' | permission)) {
                  <div class="flexRow align-center">
                    <a class="addIcon small" (click)="copyWearingParts()">
                      <span class="k-button-text">
                        <span class="icon">
                          <img src="../../../assets/icons/copy-icon.svg" class="copy">
                        </span>
                      </span>
                    </a>
                    <span>{{ t('wearingParts.copy') }}</span>
                    <span  class="tooltipContainer">
                      <span [attr.tooltip]="t('wearingParts.tooltipCopy')" flow="right" class="tooltipContainer">
                        <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                      </span>
                    </span>
                  </div>
                }
              </div>
            </div>
            @for (device of vm.devices; track device; let i = $index) {
              @if(device.wearingParts.length > 0){
                <div class="xs12col serviceWrapper flexColumn" [ngClass]="{ 'border-top': i !== 0 }">
                  <div class="flexRow align-center">
                    <h3 class="wearingPartDevice">
                      @if (device?.manufacturer?.name) {
                        <span><strong>{{t('wearingParts.manufacturer')}}:</strong> {{ device?.manufacturer?.name }}</span>
                      }
                      @if (device?.serialNumber) {
                        <span><strong>{{t('wearingParts.serialNumber')}}:</strong> {{ device?.serialNumber }}</span>
                      }
                      @if (device?.type) {
                        <span><strong>{{t('wearingParts.type')}}:</strong> {{ device?.type }}</span>
                      }
                      @if (device?.tagNumber) {
                        <span><strong>{{t('wearingParts.tagNumber')}}:</strong> {{ device?.tagNumber }}</span>
                      }
                    </h3>
                    <a
                      [routerLink]="baseUrl + device?.id"
                      [attr.tooltip]="t('open')"
                      flow="up"
                      class="actionIcon small padding-left-small">
                      <img src="../../../assets/icons/open-link-icon.svg">
                    </a>
                  </div>
                  @for (wearingPart of device.wearingParts; track wearingPart) {
                    <div class="xs12col serviceWrapper">
                      <div class="wearingPartContainer" [class.inactive-product]="!wearingPart.product.isActive">
                        <div class="content xs12col flex-wrap padding-bottom-medium">
                          <div class="xs12col s3col flex-wrap">
                            <span class="fontBold xs12col">{{ t('wearingParts.name') }}</span>
                            <span>{{ wearingPart.product.name }} </span>
                            @if (!wearingPart.product.isActive && wearingPart.product.inactiveReason) {
                              <span class="tooltipContainer">
                                <span [attr.tooltip]="wearingPart.product.inactiveReason" flow="right" class="tooltipContainer">
                                  <img class="tooltipIcon" src="../assets/icons/information-icon.svg">
                                </span>
                              </span>
                            }
                          </div>
                          <div class="xs12col s3col flex-wrap">
                            <span class="fontBold xs12col">{{ t('wearingParts.internalNumber') }}</span>
                            <span>{{ wearingPart.product.internalNumber }}</span>
                          </div>
                          <div class="xs12col s3col flex-wrap">
                            <span class="fontBold xs12col">{{ t('wearingParts.quantity') }}</span>
                            <span>{{ wearingPart.quantity }}</span>
                          </div>
                          <div class="xs12col s3col flex-wrap">
                            <span class="fontBold xs12col">{{ t('wearingParts.useInRevision') }}</span>
                            <div class="checkboxContainer">
                              <kendo-checkbox
                                type="checkbox"
                                kendoCheckBox
                                loadingIndication="/ServiceParts/createServicePart"
                                loadingIndication="/ServiceParts/deleteServicePart"
                                [disabled]="revisionStatus?.isFinalStatus == true || !wearingPart.product.isActive"
                                [(ngModel)]="wearingPart.isChecked"
                                [class.disabled-checkbox]="!wearingPart.product.isActive"
                                (click)="!wearingPart.product.isActive ? $event.preventDefault() : servicePartDialogOpen(wearingPart, device, wearingPart.quantity)">
                              </kendo-checkbox>
                            </div>
                          </div>
                          <!-- confirmation popup -->
                          @if (dialogData?.wearingPartId === wearingPart.id && servicePartDialogOpened) {
                            <kendo-dialog
                              title="{{t('servicePart')}}"
                              (close)="servicePartDialogClose('cancel')"
                              [minWidth]="250"
                              [width]="450">
                              <p style="margin: 30px; text-align: center;">
                                {{t('servicePartMessage')}}
                              </p>
                              <div style="margin: 20px; text-align: center;">
                                <input
                                  id="inputField"
                                  type="number"
                                  min="1"
                                  max="9999"
                                  [(ngModel)]="amount"/>
                                </div>
                                <kendo-dialog-actions>
                                  <button kendoButton (click)="servicePartDialogClose('cancel')">{{ t('cancel') }}</button>
                                  <button kendoButton (click)="servicePartDialogClose('confirm')" themeColor="secondary">{{ t('servicePart') }}</button>
                                </kendo-dialog-actions>
                              </kendo-dialog>
                            }
                            <!-- confirmation popup for unchecking a used wearing part -->
                            @if (dialogData?.wearingPartId === wearingPart.id && confirmUncheckDialogOpened) {
                              <kendo-dialog
                                title="{{t('servicePartUncheckTitle')}}"
                                (close)="confirmUncheckDialogClose('cancel')"
                                [minWidth]="250"
                                [width]="450">
                                <p style="margin: 30px; text-align: center;">
                                  {{t('servicePartUncheckMessage')}}
                                </p>
                                <kendo-dialog-actions>
                                  <button kendoButton (click)="confirmUncheckDialogClose('cancel')">{{ t('cancel') }}</button>
                                  <button kendoButton (click)="confirmUncheckDialogClose('confirm')" themeColor="secondary">{{ t('confirm') }}</button>
                                </kendo-dialog-actions>
                              </kendo-dialog>
                            }
                          </div>
                          <div class="footer xs12col">
                            <div class="iconItems flexRow">
                              <div class="iconItem padding-right-medium">
                                <img src="../../../assets/icons/category-icon.svg"><span>{{ wearingPart.wearingPartCategory.name }}</span>
                              </div>
                              <div class="iconItem" [hidden]="!wearingPart.location">
                                <img src="../../../assets/icons/cabinet-black-icon.svg"><span>{{ wearingPart.location }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                }
              }
              @if (vm.loading) {
                <div class="loading-container">
                  <div class="k-loading-color"></div>
                  <kendo-loader type="converging-spinner" size="large"></kendo-loader>
                </div>
              }
            </fieldset>
            <!-- Pagination controls -->
            <div class="pagination">
              <button
                (click)="previousPage()"
                [disabled]="!hasPreviousPage"
                class="pagination-btn">
                <kendo-svg-icon [icon]="caretAltLeftIcon"></kendo-svg-icon>
              </button>
              @for (page of getPageNumbers(); track page) {
                <button
                  (click)="goToPage(page)"
                  [class.active]="page === currentPage"
                  class="pagination-btn page-number">
                  {{ page }}
                </button>
              }
              <button
                (click)="nextPage()"
                [disabled]="!hasNextPage"
                class="pagination-btn">
                <kendo-svg-icon [icon]="caretAltRightIcon"></kendo-svg-icon>
              </button>
            </div>
            <!-- Page size selector -->
            <div class="page-size-selector">
              <div class="page-size-buttons">
                <button
                  type="button"
                  class="page-size-btn"
                  [class.active]="pageSize === 25"
                  (click)="onPageSizeChange(25)">
                  25
                </button>
                <button
                  type="button"
                  class="page-size-btn"
                  [class.active]="pageSize === 50"
                  (click)="onPageSizeChange(50)">
                  50
                </button>
                <button
                  type="button"
                  class="page-size-btn"
                  [class.active]="pageSize === 100"
                  (click)="onPageSizeChange(100)">
                  100
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  }